import React from 'react';

function BpjsKes(props) {
    
    return <div>Mohon maaf, saat ini informasi belom tersedia</div>
}

export default BpjsKes;